import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {AndroidIcon, IphoneIcon, GameIcon, CustomSoftIcon, SoftwareProIcon, SoftwareMainIcon} from "../../../app-constants";
import { Link } from 'gatsby'; // Import Gatsby's Link component
import HtmlParser from 'react-html-parser';


const StackItem = [
    {
        icon: AndroidIcon,
        title: 'Android app development',
        description: (
            <>
                Streamline your business operations using cutting-edge{' '}
                <Link to="/android-app-development" rel="noopener" aria-label="TekRevol">
                    Android app development services.
                </Link> {' '}
                By offering your customers a tailored experience through a visually appealing user interface, you can set yourself apart in the market. We've already assisted various industries with our robust applications. Our skilled app developers leverage their knowledge to incorporate the most up-to-date features that can enhance your business. Whether you require a native or hybrid app, we've got you covered.
            </>
        ),
    },
    {
        icon: IphoneIcon,
        title: 'Iphone app development',
        description: (
            <>
                If you want to reach Apple users, we can create a cutting-edge iOS software application for you. Given the unique demands and intricate processes involved in{' '}
                <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
                    iPhone app development,
                </Link> {' '}
                we're well-equipped to produce a robust mobile application. Simply convey your objectives, and we will transform your vision into a tangible reality through our iPhone app development services. As a result, we can deliver a customized app boasting an exceptional user interface.
            </>
        ),
    },
    {
        icon: GameIcon,
        title: 'Game app development',
        description: (
            <>
                As a leading game app development company, we have a strong track record of serving our clients. You can rely on our expertise in{' '}
                <Link to="/game-development" rel="noopener" aria-label="TekRevol">
                    game app development
                </Link> {' '}
                for both Android and iOS platforms. Furthermore, our developers have a solid skill set for crafting high-quality 2D and 3D mobile games. We make use of impressive tools and game engines such as Unity, Unreal Engine, and Lumberyards to guarantee seamless game development.
            </>
        ),
    },
    {
        icon: CustomSoftIcon,
        title: 'Custom Software Development',
        description: (
            <>
                We offer tailored solutions to businesses and organizations looking to address specific requirements that off-the-shelf software cannot fulfill. This service involves the design, development, and implementation of software applications that are uniquely crafted for the client's project. As a result, our top-tier
                {' '}
                <Link to="/custom-software-development" rel="noopener" aria-label="TekRevol">
                    Custom software development services
                </Link> {' '}
                empower businesses to adapt to changing market dynamics.
            </>
        ),
    },
    {
        icon: SoftwareProIcon,
        title: 'Software Product Development',
        description: 'Software product development services encompass the end-to-end process of designing, building, and launching software products for a wider market. These services are essential for companies looking to transform innovative concepts into market-ready software products. Our expertise in product strategy, user experience design, coding, quality assurance, and deployment is integral to delivering a successful software product.',
    },
    {
        icon: SoftwareMainIcon,
        title: 'Software Support and Maintenance',
        description: 'Software support and maintenance services are crucial for ensuring the smooth and reliable operation of software applications over time. These services include a range of activities such as troubleshooting, bug fixing, performance optimization, security updates, and feature enhancements. By proactively monitoring, managing, and addressing issues in the software, we help businesses reduce downtime and improve user satisfaction.',
    },

];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2>Experience Our Innovative App & Software Development Services in Dallas</h2>
                        <p className="impro_para">Our industry-leading Dallas software development team covers digital product creation, including native app development, game development, and dedicated development environments. Get your top-quality software built by an experienced custom software development company.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;